import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const PointElementWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${SPACING.SMALL_2};

    &:hover {
        text-decoration: underline;
    }
`;
